(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["class-feature"] && !Shopify.designMode) return;
  try {
     
  const classSlider = new Swiper('.class-feature__classes-container', {
    slidesPerView: 1.19,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    watchOverflow: true,
    allowTouchMove: true,
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4,
        allowTouchMove: false
      }
    }
  });

  // Change video on modal open
  const modalButtons = document.querySelectorAll('.class-feature__video-open');
  const video = document.querySelector('.class-video__video');
  modalButtons.forEach(button => {
    button.addEventListener('click', event => {
      const videoURL = button.dataset.video;
      video.setAttribute('src', videoURL);
      video.currentTime = 0;
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["class-highlight"] && !Shopify.designMode) return;
  try {
     
  const classSlider = new Swiper('.class-highlight__classes', {
    slidesPerView: 1.19,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    watchOverflow: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.class-highlight .swiper-button-prev',
      nextEl: '.class-highlight .swiper-button-next'
    },
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  const newsletterPopup = document.querySelector('.newsletter-popup-wrapper');
  const newsletterPopupClose = document.querySelector('.newsletter-popup__close');
  const newsletterPopupOpen = document.querySelectorAll('[href="#open-newsletter"]');

  if (getCookie('newsletterCookie')) {
    fadeOut(newsletterPopup, 400)
  } else {
    const delay = (Number(newsletterPopup.dataset.delay) * 1000) || 5000;

    setTimeout(function() {
      fadeIn(newsletterPopup, 400, 'flex');
    }, delay);
  }
  
  if (newsletterPopupClose) {
    newsletterPopupClose.addEventListener('click', event => {
      const day = 1;
  
      fadeOut(newsletterPopup, 400)
      setCookie('newsletterCookie', true, day);
    });
  }
  
  if (newsletterPopupOpen) {
    newsletterPopupOpen.forEach(btn => {
      btn.addEventListener('click', event => {
        newsletterPopup.classList.add('is-visible');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-instagram"] && !Shopify.designMode) return;
  try {
    
  const instagramSlider = new Swiper('.featured-instagram__container', {
    slidesPerView: 1.2,
    loop: true,
    spaceBetween: 15,
    watchOverflow: true,
    allowTouchMove: true,
    pagination: {
      el: '.featured-instagram__pagination'
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        spaceBetween: 20,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  const productsSlider = new Swiper('.featured-products__grid', {
    slidesPerView: 1.3,
    loop: true,
    spaceBetween: 15,
    allowTouchMove: true,
    speed: 600,
    watchOverflow: true,
    breakpoints: {
      769: {
        slidesPerView: 3,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Transparent header on scroll
  const header =  document.getElementById('shopify-section-header');
  const scrollPoint = document.getElementById('MainContent');

  document.addEventListener('scroll', function(e) {
    handleHeaderTransparency();
  });

  (() => handleHeaderTransparency())();

  function handleHeaderTransparency() {
    const scrollPosition = window.scrollY;

    if (scrollPosition > scrollPoint.offsetTop) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instructors-slider"] && !Shopify.designMode) return;
  try {
    
  const gridSlider = new Swiper('.instructors-slider__grid', {
    slidesPerView: 1.5,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    centeredSlides: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next'
    },
    breakpoints: {
      769: {
        slidesPerView: 3.5,
        centeredSlides: false,
        allowTouchMove: true
      }
    }
  }); 

  // Sync sliders
  gridSlider.on('slideChange', slider => {
    let slide = slider.realIndex + 1;

    document.querySelector('.instructors-slider__main-slide.active').classList.remove('active');
    document.querySelector(`.instructors-slider__main-slide[data-slide="${slide}"]`).classList.add('active');
  });

  const slideButtons = document.querySelectorAll('.instructors-slider__grid-slide');
  slideButtons.forEach(button => {
    button.addEventListener('click', event => {
      const slide = button.dataset.slide;
      const content = document.querySelector('.instructors-slider__content');

      if (button.classList.contains('active')) {
        slideUp(content, 300);
        content.classList.remove('active');
        button.classList.remove('active');
      } else {
        const activeSlides = document.querySelectorAll('.instructors-slider__grid-slide.active');
        if (activeSlides.length > 0) {
          activeSlides.forEach(activeSlide => {
            activeSlide.classList.remove('active')
          })
        }
        
        button.classList.add('active');

        if (!content.classList.contains('active')) {
          slideDown(content, 300);
          content.classList.add('active');
        }
      }

      document.querySelector('.instructors-slider__main-slide.active').classList.remove('active');
      document.querySelector(`.instructors-slider__main-slide[data-slide="${slide}"]`).classList.add('active');

    });
  });
  
  // Change video on modal open
  const modalButtons = document.querySelectorAll('.instructors-slider__video-open');
  const video = document.querySelector('.instructors-slider__video');
  modalButtons.forEach(button => {
    button.addEventListener('click', event => {
      console.log(button)
      const videoURL = button.dataset.url;
      video.setAttribute('src', videoURL);
      video.currentTime = 0;
      video.play();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitchen"] && !Shopify.designMode) return;
  try {
    
  // Video modal play on open
  document.querySelector('.tpc-kitchen__video-button').addEventListener('click', event => {
    document.querySelector('.kitchen-video__modal-content video').play();
  });

  // Scrolling instagram
  const scrollingImageElems = gsap.utils.toArray('.scrolling-instagram__item');
  scrollingImageElems.forEach(elem => {
    const cycle = elem.dataset.cycle;
    let delay = '';
    switch (cycle) {
      case 'first':
        delay = .2
        break; 
      case 'first':
        delay = .8
        break;
      case 'first':
        delay = .6
        break;
      default:
        break;
    }

    gsap.to(elem, { 
      opacity: 1,
      duration: 1.1,
      delay: delay,
      ease: 'linear', 
      scrollTrigger: {
        trigger: '.scrolling-instagram',
        start: "top 85%"
      }
    });
  });
console.log('asfdhaskdjf')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupClose = document.querySelector('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
    const showAfterCookieEls = document.querySelectorAll('.show-after-cookie');
    showAfterCookieEls.forEach(el => {
      el.classList.add('cookie-closed'); 
    });
    
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupClose.addEventListener('click', event => {
    const day = legalPopup.dataset.day;

    legalPopup.classList.remove('is-visible');
    setCookie('legalCookie', true, day);

    const showAfterCookieEls = document.querySelectorAll('.show-after-cookie');
    setTimeout(() => {
      showAfterCookieEls.forEach(el => {
        el.classList.add('cookie-closed'); 
      });
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  const relatedArticleSlider = new Swiper('.related-articles__container', {
    slidesPerView: 1.15,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    breakpoints: {
      769: {
        slidesPerView: 3
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contest"] && !Shopify.designMode) return;
  try {
    
  const slideshowSlider = new Swiper('.contest__image-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    watchOverflow: true,
    speed: 400,
    pagination: {
      el: '.contest__pagination',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const loop = document.querySelector('.product__media-list').dataset.loop === 'true';
  const slidesPerView = document.querySelector('.product__media-list').dataset.loop === 'true' ? 1.1 : 1;
  const productSlider = new Swiper('.product__media-list', {
    loop: loop,
    slidesPerView: slidesPerView,
    spaceBetween: 20,
    allowTouchMove: true,
    pagination: {
      el: '.product__media-pagination'
    },
    breakpoints: {
      769: {
        slidesPerView: 1,
        allowTouchMove: false
      }
    }
  });

  // Sync slider with thumbnails
  productSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    const activeThumb = document.querySelector('.product__media-thumbnail-item.active');
    const newThumb = document.querySelector(`.product__media-thumbnail-item[data-index="${idx}"]`);
    
    activeThumb.classList.remove('active');
    newThumb.classList.add('active');
  });

  // Sync thumbnails with slider
  const thumbnails = document.querySelectorAll('.product__media-thumbnail-item');
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', event => {
      let idx = Number(event.currentTarget.dataset.index);
  
      productSlider.slideToLoop(idx);
    });
  });

  // Product zoom slider
  const productZoomSlider = new Swiper('.product-zoom__slider', {
    loop: true,
    pagination: {
      el: '.product-zoom__slider-pagination',
    },
    navigation: {
      nextEl: '.product-zoom__slider-button.swiper-button-next',
      prevEl: '.product-zoom__slider-button.swiper-button-prev',
    }
  });

  // Open correct slide
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const idx =  Number(event.currentTarget.dataset.index);

      productZoomSlider.slideTo(idx);
    });
  })

  // Close Modal
  document.querySelector('.modal__close').addEventListener('click', event => {
    MicroModal.close('product-zoom');
  });

  // Product Dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');
  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');

      parent.classList.toggle('active');
      slideToggle(content, 400);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-bar"] && !Shopify.designMode) return;
  try {
    
  const links = document.querySelectorAll('.navigation-bar__item');
  const barHeight = document.querySelector('.navigation-bar').clientHeight;

  // Highlight on scroll
  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;

    links.forEach(link => {
      const section = document.querySelector(`#${link.dataset.section}`);

      if (section) {
        if ((section.offsetTop - barHeight - 30) <= fromTop && (section.offsetTop - barHeight - 30) + section.clientHeight > fromTop) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });

  // Scroll to link
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const section = document.querySelector(`#${event.currentTarget.dataset.section}`)

      window.scrollTo({
        top: section.offsetTop - barHeight - 30,
        behavior: "smooth"
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
     
  const productSlider = new Swiper('.product-slider__slider', {
    slidesPerView: 1.15,
    loop: false,
    spaceBetween: 20,
    speed: 600,
    centerInsufficientSlides: true,
    watchOverflow: true,
    navigation: {
      prevEl: '.product-slider .swiper-button-prev',
      nextEl: '.product-slider .swiper-button-next'
    },
    breakpoints: {
      651: {
        slidesPerView: 2
      },
      851: {
        slidesPerView: 2.5
      },
      951: {
        slidesPerView: 3
      },
      1051: {
        slidesPerView: 3.5
      },
      1151: {
        slidesPerView: 4
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-instagram"] && !Shopify.designMode) return;
  try {
    
  const scrollingImageElems = gsap.utils.toArray('.scrolling-instagram__item');
  scrollingImageElems.forEach(elem => {
    const cycle = elem.dataset.cycle;
    let delay = '';
    switch (cycle) {
      case 'first':
        delay = .2
        break;
      case 'first':
        delay = .8
        break;
      case 'first':
        delay = .6
        break;
      default:
        break;
    }

    gsap.to(elem, { 
      opacity: 1,
      duration: 1.1,
      delay: delay,
      ease: 'linear', 
      scrollTrigger: {
        trigger: '.scrolling-instagram',
        start: "top 85%"
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialsSlider = new Swiper('.testimonials-slider__swiper', {
    loop: true,
    spaceBetween: 60,
    effect: 'fade',
    speed: 800,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.testimonials-slider__pagination'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-slider"] && !Shopify.designMode) return;
  try {
    
  const contentSlider = new Swiper('.text-image-slider__content-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    speed: 600,
    navigation: {
      prevEl: '.text-image-slider .swiper-button-prev',
      nextEl: '.text-image-slider .swiper-button-next'
    }
  });

  const imageSlider = new Swiper('.text-image-slider__images', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    speed: 800
  }); 

  // Sync sliders
  contentSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    imageSlider.slideToLoop(idx);
  });

  imageSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    contentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transformations"] && !Shopify.designMode) return;
  try {
     
  const transformSlider = new Swiper('.transformations__slider', {
    loop: true,
    spaceBetween: 0,
    speed: 600,
    pagination: {
      el: '.transformations__slider-pagination',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();
})();
